<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">Manage OTP Notification</span>
        </div>
    </div>
    <div class="card card_content all_class">
        <form [formGroup]="form">
            <div class="row d-flex  align-items-center flex-wrap grid-margin mb-2">
                <div class="col-md-4">
                    <!-- <button type="button" class="btn btn-secondary mr-2" (click)="clearFilter()">
                         <i class="fa fa-refresh"></i> Refresh
                    </button> -->
                    <app-button (refreshClicked)="clearFilter()"></app-button>
                </div>
                <div class="col-md-4 padd-right-file" style="display: flex;">
                    <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'searchText-mat-field'">
                        <mat-label>Search</mat-label>
                        <div class="search-input-container">
                            <input formControlName="searchText" placeholder="Enter Contact Number" id="search" matInput
                                type="text" #searchInput>
                        </div>
                    </mat-form-field>
                    <button matSuffix mat-icon-button aria-label="Search" class="badge bg-light-blue image-button"
                        (click)="search()">
                        <mat-icon style="color: white;">search</mat-icon>
                    </button>
                </div>
            </div>
        </form>

        <div class="table-responsive mt-2 mb-4">
            <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc">

                <!-- <ng-container matColumnDef="CustomerName">
                <mat-header-cell *matHeaderCellDef mat-sort-header="CustomerName">Customer Name</mat-header-cell>
                <mat-cell *matCellDef="let dataField">
                    <p class="text-truncate txtalign"> {{dataField.customerName}}</p>
                </mat-cell>
            </ng-container> -->

                <!-- <ng-container matColumnDef="CustomerCode">
                <mat-header-cell *matHeaderCellDef mat-sort-header="CustomerCode" style="width: 25%;"> Customer
                    Reference Number</mat-header-cell>
                <mat-cell *matCellDef="let dataField">
                    <p class="text-truncate txtalign">{{dataField.customerCode}} </p>
                </mat-cell>
            </ng-container> -->

                <ng-container matColumnDef="recipient">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="recipient" style="width: 35%;">Recipient</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign">{{dataField.recipient}}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="OTP">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="otp" style="width: 30%;">OTP</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign">{{dataField.otp}}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="TimeStamp">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="TimeStamp">TimeStamp</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign">{{dataField.creationts| date:'dd-MM-yyyy hh:mm a'}}</p>
                    </mat-cell>
                </ng-container>

                <!-- <ng-container matColumnDef="MessageStatusType">
                <mat-header-cell *matHeaderCellDef mat-sort-header="MessageStatusType">Status</mat-header-cell>
                <mat-cell *matCellDef="let dataField"> style="width: 40%;"
                    <p class="text-truncate txtalign"
                        [style.color]="dataField.messageStatusTypeDesc==='Active'?'green':'red'">
                        {{dataField.messageStatusTypeDesc}}</p>
                </mat-cell>
            </ng-container> -->


                <ng-container matColumnDef="action">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="action">Action</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">

                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

                <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
                </mat-row>
            </mat-table>
            <div *ngIf="data.length == 0" class="no-data-message">
                <p>No data found</p>
            </div>
        </div>
        <div class="table_pagenation" [hidden]="dataSource?.filteredData.length<=50">
        <mat-paginator #paginator [length]="dataSource?.filteredData.length || 0" [pageIndex]="0" [pageSize]="50"
            [pageSizeOptions]="[50, 100]">
        </mat-paginator>
    </div>
    </div>

    
</div>